import { Injectable, NgZone } from '@angular/core';
import ServiceBell, {
  ServiceBellAPI,
  ServiceBellOptions,
} from '@servicebell/widget';

import { FeatureToggleService } from './feature-toggle.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceBellService {
  #isHidingOnCollapse :boolean = false;
  #sbHideOnCollapseListener :Function;

  constructor(
    private _ngZone :NgZone,
    private _feature :FeatureToggleService,
  ) {}

  connect() {
    this.#ServiceBellOutsideAngular('connect');
  }

  disconnect() {
    this.#ServiceBellOutsideAngular('disconnect');
  }

  identify(
    uniqueId :string,
    data :{
      email :string;
      displayName :string;
      account :string;
      tenantId :string;
    },
  ) {
    this.#ServiceBellOutsideAngular('identify', uniqueId, data);
  }

  init(options ?:ServiceBellOptions) {
    this.#ServiceBellOutsideAngular(
      'init',
      'a26460e51f374156b88dadcaa9178751',
      options,
    );
  }

  open() {
    this.#ServiceBellOutsideAngular('show');
    this.#ServiceBellOutsideAngular('expand');
  }

  close() {
    this.#ServiceBellOutsideAngular('collapse');
    !this.#isHidingOnCollapse && this.#ServiceBellOutsideAngular('hide');
  }

  startHideOnCollapse(callback ?:Function) {
    if (!this._feature.isActive('utah_UTAH-76_service_bell_widget')) {
      return;
    }

    this.#sbHideOnCollapseListener =
      this.#buildAutoHideOnCollapseListener(callback);

    this._ngZone.runOutsideAngular(() => {
      // @ts-ignore (ts doesn't like the custom `'sb:collapse'` event name)
      window.addEventListener('sb:collapse', this.#sbHideOnCollapseListener);
    });

    this.#isHidingOnCollapse = true;
  }
  stopHideOnCollapse() {
    if (!this._feature.isActive('utah_UTAH-76_service_bell_widget')) {
      return;
    }

    this._ngZone.runOutsideAngular(() => {
      // @ts-ignore (ts doesn't like the custom `'sb:collapse'` event name)
      window.removeEventListener('sb:collapse', this.#sbHideOnCollapseListener);
    });

    this.#isHidingOnCollapse = false;
  }

  #buildAutoHideOnCollapseListener(callback ?:Function) :() => void {
    return () => {
      this.#ServiceBellOutsideAngular('hide');
      callback?.();
    };
  }

  /**  Thin wrapper around ServiceBell to run it outside Angular's zone. */
  #ServiceBellOutsideAngular(method :keyof ServiceBellAPI, ...params :any) {
    if (!this._feature.isActive('utah_UTAH-76_service_bell_widget')) {
      return;
    }

    this._ngZone.runOutsideAngular(() => {
      ServiceBell(method, ...params);
    });
  }
}
